<template>
	<div class="view-conversation">
		<div
			class="conversation-list-container"
			:inconversation="isInConversation"
			:conversationinfo="isInConversation && conversationInfoOpen"
		>
			<ConversationListNavbar />
			<template v-if="anyProviderAvailable.length === 0">
				<div class="no-provider-available-container">
					<div class="card shadow">
						<span class="card-title clr-bg bgclr-secondary">
							No providers currently available!
						</span>
					</div>
				</div>
			</template>
			<template
				v-else-if="
					(oneProviderMode &&
						!isReady(getAllConversationProviders[0].name)) ||
						anyProviderReady.length === 0
				"
			>
				<div class="one-provider-mode-container">
					<ConversationProviderManager class="card shadow" />
				</div>
			</template>
			<template v-else>
				<ConversationList
					@update:conversationInfoOpen="
						toggleConversationInfoOpen($event)
					"
				/>
			</template>
		</div>
		<div
			v-if="isInConversation"
			class="conversation-container"
			:inconversation="isInConversation"
			:conversationinfo="isInConversation && conversationInfoOpen"
			:key="
				isInConversation
					? 'conversation_' +
					  getCurConversation.providerName +
					  '_' +
					  getCurConversation.id
					: null
			"
		>
			<ConversationNavbar
				@update:conversationInfoOpen="
					toggleConversationInfoOpen($event)
				"
			/>
			<Conversation />
		</div>
		<!-- <div v-else class="conversation-container" innoconversation="true">
            <span>Please select a conversation from the left or use the conversation provider to start a new conversation</span>
        </div> -->
		<div
			v-if="isInConversation && conversationInfoOpen"
			class="conversation-info-container"
			:conversationinfo="isInConversation && conversationInfoOpen"
			:key="
				isInConversation && conversationInfoOpen
					? 'conversation-info_' +
					  getCurConversation.providerName +
					  '_' +
					  getCurConversation.id
					: null
			"
		>
			<ConversationInfoNavbar
				@update:conversationInfoOpen="
					toggleConversationInfoOpen($event)
				"
			/>
			<ConversationInfo />
		</div>
	</div>
</template>

<script>
import ConversationListNavbar from '../components/ConversationListNavbar.vue';
import ConversationList from '../components/ConversationList.vue';
import ConversationNavbar from '../components/ConversationNavbar.vue';
import Conversation from '../components/Conversation.vue';
import ConversationInfoNavbar from '../components/ConversationInfoNavbar.vue';
import ConversationInfo from '../components/ConversationInfo.vue';
import ConversationProviderManager from '../components/ConversationProviderManager.vue';

import { mapGetters } from 'vuex';

export default {
	name: 'ViewConversation',
	components: {
		ConversationListNavbar,
		ConversationList,
		ConversationNavbar,
		Conversation,
		ConversationInfoNavbar,
		ConversationInfo,
		ConversationProviderManager
	},
	data() {
		return {
			conversationInfoOpen: false
		};
	},
	computed: {
		isInConversation() {
			return !!this.getCurConversation;
		},
		anyProviderAvailable() {
			let available = [];

			for (
				let providerI = 0;
				providerI < this.getAllConversationProviders.length;
				providerI++
			) {
				let provider = this.getAllConversationProviders[providerI];

				if (this.isAvailable(provider.name)) {
					available.push(provider);
					break;
				}
			}

			return available;
		},
		anyProviderReady() {
			let ready = [];

			for (
				let providerI = 0;
				providerI < this.getAllConversationProviders.length;
				providerI++
			) {
				let provider = this.getAllConversationProviders[providerI];

				if (this.isReady(provider.name)) {
					ready.push(provider);
					break;
				}
			}

			return ready;
		},
		...mapGetters({
			getCurConversation: 'ConversationProviders/getCurConversation',
			getAllConversationProviders:
				'ConversationProviders/getAllConversationProviders',
			oneProviderMode: 'ConversationProviders/oneProviderMode',
			isAvailable: 'ConversationProviders/isAvailable',
			isReady: 'ConversationProviders/isReady'
		})
	},
	methods: {
		toggleConversationInfoOpen(to = false) {
			this.conversationInfoOpen = !!to;
		}
	}
};
</script>
